// assets
import { IconUserCog } from '@tabler/icons-react';

// constant
const icons = { IconUserCog };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const home = {
  Key: 'config',
  Type: 'group',
  Url: '/config',
  Items: [
    {
      Key: 'config',
      Text: 'Configuration',
      Type: 'item',
      Url: '/config',
      icon: icons.IconUserCog,
      breadcrumbs: false
    }
  ]
};

export default home;
